export default __webpack_public_path__ + "static/media/rfq.8072d8a0.png";